<template>
  <b-modal
    id="extra-fee-history-modal"
    ref="historyModal"
    :title="`Historique des Frais Extra - ${orderId}`"
    size="lg"
    hide-footer
    @hidden="reset"
  >
    <div v-if="historyLoading" class="text-center my-3">
      <b-spinner variant="primary" />
      <div class="mt-1">Chargement de l'historique...</div>
    </div>

    <div v-else-if="!history || history.length === 0" class="text-center my-3">
      <feather-icon icon="InfoIcon" size="48" class="text-muted mb-1" />
      <p class="text-muted">Aucun historique trouvé pour cette commande.</p>
    </div>

    <div v-else class="p-1">
      <div class="timeline">
        <div v-for="(item, index) in history" :key="index" class="timeline-item pb-2 border-left ml-2 pl-2 position-relative">
          <!-- Timeline point -->
          <div class="timeline-point position-absolute bg-primary rounded-circle" style="width: 12px; height: 12px; left: -7px; top: 0;"></div>

          <div class="d-flex justify-content-between align-items-center mb-50">
            <span class="font-weight-bolder text-dark">{{ formatDate(item.modification_date) }}</span>
            <b-badge pill variant="light-primary">{{ item.user_role }}</b-badge>
          </div>

          <div class="mb-50">
            <feather-icon icon="UserIcon" size="14" class="mr-25" />
            <span class="font-weight-bold">{{ item.modified_by_name }}</span>
            <span class="mx-50 text-muted">|</span>
            <feather-icon icon="HomeIcon" size="14" class="mr-25" />
            <span>{{ item.depot_name }}</span>
          </div>

          <div class="bg-light p-1 rounded mb-50">
            <div class="d-flex justify-content-between mb-25">
              <span>Ancien Total:</span>
              <span class="text-muted">{{ formatPrice(item.previous_delivery_fee) }} DT</span>
            </div>
            <div class="d-flex justify-content-between mb-25 text-primary font-weight-bold">
              <span>Ajout Extra:</span>
              <span>+ {{ formatPrice(item.extra_amount_added) }} DT</span>
            </div>
            <hr class="my-50 border-white">
            <div class="d-flex justify-content-between font-weight-bolder text-dark">
              <span>Nouveau Total:</span>
              <span>{{ formatPrice(item.new_total_delivery_fee) }} DT</span>
            </div>
          </div>

          <div v-if="item.reason" class="font-italic text-secondary small">
            <strong>Raison:</strong> {{ item.reason }}
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import {
  BModal, BSpinner, BBadge,
} from 'bootstrap-vue'
import { mapState, mapActions } from 'vuex'
import dayjs from 'dayjs'

export default {
  components: {
    BModal,
    BSpinner,
    BBadge,
  },
  data() {
    return {
      orderId: '',
    }
  },
  computed: {
    ...mapState('extraFees', ['history', 'historyLoading']),
  },
  methods: {
    ...mapActions('extraFees', ['fetchHistory']),
    open(orderId) {
      this.orderId = orderId
      this.fetchHistory({ order_id: orderId })
      this.$refs.historyModal.show()
    },
    reset() {
      this.orderId = ''
    },
    formatDate(value) {
      if (!value) return ''
      return dayjs(value).format('DD/MM/YYYY HH:mm:ss')
    },
    formatPrice(value) {
      if (value === null || value === undefined) return '0.000'
      return parseFloat(value).toFixed(3)
    },
  },
}
</script>

<style lang="scss" scoped>
.timeline-item:last-child {
  border-left: none !important;
}
</style>
